import { betriebsereignisDatenvollsteandigkeit, betriebsereignisKommunikation, betriebsstatus } from "../../utils/apiTypes";

export interface messstellenListe {
    messstelle: string;
    kommunikationStatus: number;
    datenStatus: number;
}

export interface aktiveMesspunkt {
    name: string;
    umspannwerk: string;
    schaltfeld: string;
    messgeraetSeriennummer: string;
    messgeraetIP: string;
    routerIP: string;
    routerSeriennummer: string;
}

export enum sortProp {
    kommunikation,
    datenvollstaendigkeit
}

export enum sortOrder {
    errorFirst,
    errorLast
}

export interface sort {
    sortProp: sortProp,
    sortOrder: sortOrder | null,
}

export interface betriebsereignisState {
    betriebsstatusListe: Array<betriebsstatus>;
    maxKommunication: number;
    numberOfDevicesKommunikation: number;
    maxDatenvollsteandigkeit: number;
    numberOfDevicesDatenvollstaendigkeit: number;
    aktiveMesspunkt: Array<aktiveMesspunkt>;
    datenvollsteandigkeitListe: Array<betriebsereignisDatenvollsteandigkeit>;
    kommunikationListe: Array<betriebsereignisKommunikation>;
    messstellenKommunikationListe:  Array<betriebsereignisKommunikation>;
    messstellenDatenvollstaendigkeitListe: Array<betriebsereignisDatenvollsteandigkeit>;
    betriebsereignisListe: Array<betriebsereignisKommunikation>;
    BetriebsereignisseLoading: boolean;
    datenvollsteandigkeitLoading: boolean;
    kommunikationLoading: boolean;
    betriebsereignisLoading: boolean;
    selectedMessstelle: string;
    sort: sort;
}